import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_ReportService } from './Utilities.report.index';
import { Invoices_ReportService } from './Invoices.report.index';
import { Notifications_ReportService } from './Notifications.report.index';
import { Inventory_ReportService } from './Inventory.report.index';
import { FootPrintApiManager_ReportService } from './FootPrintApiManager.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_ReportService);
    this.Invoices = this.injector.get(Invoices_ReportService);
    this.Notifications = this.injector.get(Notifications_ReportService);
    this.Inventory = this.injector.get(Inventory_ReportService);
    this.FootPrintApiManager = this.injector.get(FootPrintApiManager_ReportService);
  }
    public Utilities: Utilities_ReportService;
    public Invoices: Invoices_ReportService;
    public Notifications: Notifications_ReportService;
    public Inventory: Inventory_ReportService;
    public FootPrintApiManager: FootPrintApiManager_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

